import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck"; // TODO: Very generic Logger, to be worked upon

var logLevel = process.env.LOG_LEVEL || process.env.REACT_APP_LOG_LEVEL || 'error';
var availableLogLevels = ['debug', 'log', 'info', 'warn', 'error'];

var noop = function noop() {};

var Logger =
/* eslint-disable no-console */
function Logger() {
  var _this = this;

  _classCallCheck(this, Logger);

  var levelFound = false;
  availableLogLevels.forEach(function (level) {
    if (level === logLevel.toLowerCase() || levelFound) {
      levelFound = true;
      _this[level] = console[level];
    } else {
      _this[level] = noop;
    }
  });
}
/* eslint-enable no-console */
;

var logger = new Logger();
export default logger;